import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/WarningPanel.css';

WarningPanel.propTypes = {
    message: PropTypes.string.isRequired,
};

function WarningPanel(props) {
    const {
        message,
    } = props;
    return (
        <div className="warning-panel">
            <FontAwesomeIcon icon="exclamation-triangle" className="warning-panel--icon" />
            <span className="warning-panel--message">
                {message}
            </span>
        </div>
    );
}

export default WarningPanel;
